import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const products = [
  {
    name: "Signulu",
    logo: "/assets/signuluone-lockup.png",
    desc: "Signulu is a cloud-based eSignature software platform developed for the utmost convenience of individuals, professionals, and businesses...",
    href: "https://signulu.signuluone.com/",
  },
  {
    name: "DMS",
    logo: "/assets/logo-dms.webp",
    desc: "Intelligent Secure Document Management for Modern Enterprises. Centralize, secure, and manage all your critical documents with AES-256 encryption...",
    href: "https://dms.signuluone.com/",
  },
  {
    name: "QuikHyr AI",
    logo: "/assets/logo-quikhyr.svg",
    desc: "Unifies hiring workflows, intelligent data, and AI insights into one secure, cloud-native platform – so you hire smarter, faster, and worry-free...",
    href: "https://quikhyr.ai/",
  },
  {
    name: "Attainica",
    logo: "/assets/logo-attainica.png",
    desc: "Attainica is an efficacious staffing ERP system. A one-stop destination for all your staffing hassles.",
    href: "https://www.attainica.com/",
  },
];

const Products = () => (
  <section id="products" data-testid="products-section" className="py-24 lg:py-16 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-2xl mb-14"
      >
        <span className="text-xs font-semibold tracking-[0.25em] uppercase text-miti-blue">Our Products</span>
        <h2 className="mt-4 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900">
          Our Products
        </h2>
        <p className="mt-4 text-base md:text-lg text-slate-500">
          At Millennium Infotech, we foster innovation, deliver technology, and render contemporary business
          solutions. Along with this, we developed exceptional products that empower organizations.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-y-0 lg:divide-x lg:divide-slate-100">
        {products.map((p, i) => (
          <motion.div
            key={p.name}
            data-testid={`product-card-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className="group flex flex-col items-center text-center px-6 lg:px-8"
          >
            <div className="h-16 flex items-center justify-center">
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                className="max-h-14 max-w-[200px] object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </div>
            <h3 className="mt-8 font-heading font-bold text-2xl text-slate-900 group-hover:text-miti-blue transition-colors duration-300">
              {p.name}
            </h3>
            <p className="mt-4 text-sm md:text-base text-slate-500 leading-relaxed flex-1">{p.desc}</p>
            <a
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-explore-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="mt-8 inline-flex items-center justify-center rounded-lg bg-miti-blue px-10 py-3 text-sm font-semibold text-white group-hover:bg-miti-navy group-hover:shadow-lg group-hover:shadow-miti-blue/25 transition-all duration-300"
            >
              Explore
            </a>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="mt-14 flex justify-center"
      >
        <a
          href="/our-products"
          data-testid="products-explore-all"
          className="group inline-flex items-center gap-2 rounded-lg bg-miti-blue px-6 py-3 text-sm font-semibold text-white hover:bg-miti-navy transition-colors duration-300"
        >
          Explore All Products
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
        </a>
      </motion.div>
    </div>
  </section>
);

export default Products;
